module.exports = __webpack_public_path__ + "static/media/bgVid.d3c39ea7.mp4";